import React from 'react';
import { Impersonation } from 'ui/components';
import { FormattedMessage } from 'ui/i18n';

export default () =>
	<div className="navbar-controls navbar-right Header__impersonation tooltip">
		<div className="toolTipBottom">
			<FormattedMessage id="impersonation.searchForLNBP" />
			<i />
		</div>
		<Impersonation />
	</div>;



// WEBPACK FOOTER //
// ./src/ui/components/Header/Impersonation.js